const ParametroEnum = {
  QuantidadeMinimaProdutoRateio: 1,
  MargemRateio: 2,
  VersaoSistema: 3
};

export default ParametroEnum;
